:host {
  display: block;
  position: relative;
}

.customer-details {
  display: grid;
  gap: 0.75em;
}
